'use strict';

const { AepsWidget } = require('./AepsWidget');
const { AepsOnboardingWidget } = require('./AepsOnboardingWidget');
const { DmtWidget } = require('./DmtWidget');
const { DmtOnboardingWidget } = require('./DmtOnboardingWidget');
const { UpiWidget } = require('./UpiWidget');
const { MerchantSignupWidget } = require('./MerchantSignupWidget');
const { MerchantOnboardingWidget } = require('./MerchantOnboardingWidget');
const { Checkout, bucksboxHandler } = require('./Checkout');

module.exports = {
  AepsWidget,
  AepsOnboardingWidget,
  DmtWidget,
  DmtOnboardingWidget,
  UpiWidget,
  MerchantSignupWidget,
  MerchantOnboardingWidget,
  Checkout,
  bucksboxHandler,
};
